import React from 'react';
import loadable from '@loadable/component';

const LoadableComponent = loadable(() =>
  import(/* webpackChunkName: "graph" */ './important-dates')
);

const ImportantDatesLoader = props => <LoadableComponent {...props} />;

export default ImportantDatesLoader;
